module.exports = __webpack_public_path__ + "static/media/download-disabled.e310ac86.svg";